import { render } from "./BaseAdminTableTools.vue?vue&type=template&id=35aa6f4c"
import script from "./BaseAdminTableTools.vue?vue&type=script&lang=js"
export * from "./BaseAdminTableTools.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__